export default __webpack_public_path__ + "static/media/acguy.76fb29e0.png";